import asyncSeries from 'async/series';
import CoinStore from './coin_store';
import OrderHistoryStore from './order_history_store';
import WalletStore from './wallet_store';

export default {
  init,
};

function init(done) {
  asyncSeries([CoinStore.init, WalletStore.init, OrderHistoryStore.init], done);
}
